import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "../styles";
import localStyles from "./styles";

import { Grid, Button } from "@material-ui/core";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Select from "../../../../../common/StyledSelect";
import { compose } from "recompose";
import {
  HOOK_TYPE_OPTION,
} from "../../constants";
import constants from "../../DispatchPanel/constants";
import { postData } from "../../../../../../api/componentAPIs";
import CustomTextField from "../../DriverPopUp/common/CustomTextField";
import MESSAGES from "../../../../../../appMessages";
import Events from "../../../../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import isEqual from "lodash.isequal";
import { canAddTrailer, getArrivedAtStopId } from "../utils";

class TrailerHook extends React.Component {
  constructor(props) {
    super(props);
    this.attachedTrailers = this.getCurrentTrailers();
    this.state = {
      hookTrailersError: [],
      hookTrailers: [""],
      selectedHookType: HOOK_TYPE_OPTION.Trailer,
      hookTypes: this.getHookTypes(),
    };
  }

  componentDidMount() {
    Events.on("trailerHooked", this.trailerHookedStatus);
    Events.on("bobtailProcessed", this.bobtailProcessedStatus);
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.routeData, this.props.routeData)) {
      this.attachedTrailers = this.getCurrentTrailers();
      this.setState({ hookTypes: this.getHookTypes() });
    }
    if (prevProps.trailerList != this.props.trailerList) {
      this.setState({
        hookTrailersError: this.getErrors(),
      });
    }
  }

  componentWillUnmount() {
    Events.off("trailerHooked", this.trailerHookedStatus);
    Events.off("bobtailProcessed", this.bobtailProcessedStatus);
  }

  checkStatus = (data, type) => {
    const { success } = data;
    if (success) {
      this.onTrailerHookSucceed(type);
    } else {
      this.onTrailerHookFailed(type);
    }
  };

  trailerHookedStatus = (data) => {
    this.checkStatus(data, HOOK_TYPE_OPTION.Trailer);
  };

  bobtailProcessedStatus = (data) => {
    this.checkStatus(data, HOOK_TYPE_OPTION.Bobtail);
  };

  getCurrentTrailers = () => {
    return this.props.currentDriverRoutes
      .filter(
        (route) =>
          route.trailerNumber &&
          route.trailerNumber !== constants.TRAILER_NUMBER_FOR_BOBTAIL
      )
      .map((route) => {
        return route.trailerNumber;
      });
  };

  isBobtail = () => {
    return this.props.currentDriverRoutes.filter(
      (route) => route.trailerNumber === constants.TRAILER_NUMBER_FOR_BOBTAIL
    ).length;
  };

  getHookTypes = () => {
    const isBobtailDisabled =
      this.attachedTrailers.length !== 0 || this.isBobtail();
    return Object.keys(HOOK_TYPE_OPTION).map((key) => ({
      label: HOOK_TYPE_OPTION[key],
      value: key,
      isDisabled: key === HOOK_TYPE_OPTION.Bobtail ? isBobtailDisabled : false,
    }));
  };

  handleTrailerNumberChange = (index, value) => {
    let trailers = this.state.hookTrailers;
    trailers[index] = value;
    this.setState(
      {
        hookTrailers: trailers,
      },
      () => this.updateTrailerErrors(index, value)
    );
  };
  updateTrailerErrors = (trailerIndex, value) => {
    const trailers = this.props.trailerList;

    this.setState((prevState) => ({
      hookTrailersError: prevState.hookTrailersError.map((error, index) => {
        if (index === trailerIndex) {
          return this.checkValidTrailerNumber(value, trailers);
        }
        return error;
      }),
    }));
  };
  handleAddtrailer = () => {
    this.setState((prevState) => ({
      hookTrailers: [...prevState.hookTrailers, ""],
    }));
  };

  removeHookTrailer = () => {
    const { hookTrailers } = this.state;
    this.setState({
      hookTrailers: [...hookTrailers.splice(0, hookTrailers.length - 1)],
    });
  };

  checkValidTrailerNumber = (value, trailers) => {
    const { allowedTrailerStatusesToHook } = this.props;
    if (!value) {
      return "* Required";
    }
    const trailer = trailers.find((item) => item.trailerNumber === value);
    if (!trailer) {
      return "Invalid trailer number";
    }

    if (allowedTrailerStatusesToHook.includes(trailer.trailerStatus)) {
      const hookedTrailers = [
        ...this.state.hookTrailers,
        ...this.getCurrentTrailers(),
      ];
      const numberOfOccurance = hookedTrailers.filter(
        (val) => val === value
      ).length;
      if (numberOfOccurance > 1) {
        return "Duplicate trailer entry";
      }
    } else {
      return "Invalid trailer status";
    }

    return null;
  };

  getTrailerNumberErrors = () => {
    const trailers = this.props.trailerList;

    return this.state.hookTrailers.map((item) => {
      return this.checkValidTrailerNumber(item, trailers);
    });
  };

  getErrors = () => {
    return this.state.selectedHookType === HOOK_TYPE_OPTION.Trailer
      ? this.getTrailerNumberErrors()
      : [];
  };

  onHookTrailer = () => {
    const errors = this.getErrors();
    this.setState({
      hookTrailersError: errors,
    });
    const hasValidInputs = Object.values(errors).every(
      (v) => v === null
    );
    if (!hasValidInputs) {
      return;
    }

    const { userData, routeData } = this.props;

    let requestData = {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      dispatchId: routeData.dispatchId,
    };

    let apiName = "Bobtail";

    this.props.showHideLoader(true);
    if (this.state.selectedHookType === HOOK_TYPE_OPTION.Trailer) {
      apiName = "TrailerHook";
      requestData.trailerNumbers = this.state.hookTrailers;
      requestData.arrivedStopId = getArrivedAtStopId(routeData);
    }

    postData(apiName, requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onTrailerHookFailed(this.state.selectedHookType);
        }
      })
      .catch(() => {
        this.onTrailerHookFailed(this.state.selectedHookType);
      });
  };

  onTrailerHookFailed = (type) => {
    const msg =
      type === HOOK_TYPE_OPTION.Trailer
        ? MESSAGES.TRAILER_HOOKED.FAILURE
        : MESSAGES.BOBTAIL_PROCESSED.FAILURE;
    this.props.enqueueSnackbar(msg, {
      variant: "error",
    });
    this.props.showHideLoader(false);
  };

  onTrailerHookSucceed = (type) => {
    const msg =
      type === HOOK_TYPE_OPTION.Trailer
        ? MESSAGES.TRAILER_HOOKED.SUCCESS
        : MESSAGES.BOBTAIL_PROCESSED.SUCCESS;
    this.props.enqueueSnackbar(msg, {
      variant: "success",
    });
    this.props.showHideLoader(false);
  };

  render() {
    const attachedTrailersCount = this.attachedTrailers.length;
    const { classes, isLoading, maxAllowedTrailerCount } = this.props;
    const { hookTrailers, selectedHookType } = this.state;
    const isAddTrailerDisabled = canAddTrailer(
      attachedTrailersCount,
      hookTrailers.length,
      maxAllowedTrailerCount
    );
    const isLastEntry = hookTrailers.length === 1;
    const isBobtailSelected = selectedHookType === HOOK_TYPE_OPTION.Bobtail;
    const isSectionDisabled = attachedTrailersCount >= maxAllowedTrailerCount;
    return (
      <React.Fragment>
        <Grid
          container
          className={`${classes.containerStyle} ${
            isSectionDisabled ? classes.sectionDisabled : null
          }`}
        >
          <Grid item xs={12}>
            <div className={classes.sectionTitle}>Trailer Hook</div>
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "HookType",
                  label: "Hook Type",
                  variant: "outlined",
                }}
                value={this.state.selectedHookType}
                onChange={(val) =>
                  this.setState({
                    selectedHookType: val?.value,
                  })
                }
                isNotClearable={true}
                data={this.state.hookTypes}
                rootClass={classes.selectRoot}
              />
            </div>
            <>
              {!isBobtailSelected &&
                this.state.hookTrailers.map((trailerNumber, index) => (
                  <div className={classes.searchRow} key={index}>
                    <CustomTextField
                      label="Trailer number"
                      value={trailerNumber}
                      handleChange={(val) =>
                        this.handleTrailerNumberChange(index, val)
                      }
                      error={this.state.hookTrailersError[index]}
                      margin="dense"
                    />
                  </div>
                ))}
              <div className={classes.actionButtons}>
                {isBobtailSelected ? null : (
                  <>
                    <Button
                      color="primary"
                      variant="outlined"
                      className={classes.confirmButton}
                      onClick={this.removeHookTrailer}
                      disabled={isLoading || isLastEntry || isSectionDisabled}
                      classes={{
                        root: classes.confirmButton,
                        disabled: classes.disabledConfirmButton,
                      }}
                    >
                      CANCEL
                    </Button>
                    <Button
                      color="primary"
                      variant="outlined"
                      className={classes.confirmButton}
                      disabled={
                        isLoading || isAddTrailerDisabled || isSectionDisabled
                      }
                      onClick={this.handleAddtrailer}
                      classes={{
                        root: classes.confirmButton,
                        disabled: classes.disabledConfirmButton,
                      }}
                    >
                      ADD TRAILER
                    </Button>
                  </>
                )}
                <Button
                  color="primary"
                  variant="contained"
                  className={classes.confirmButton}
                  onClick={this.onHookTrailer}
                  disabled={isLoading || isSectionDisabled}
                  classes={{
                    root: classes.confirmButton,
                    disabled: classes.disabledConfirmButton,
                  }}
                >
                  HOOK
                </Button>
              </div>
            </>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default compose(
  withSnackbar,
  withUserProfile,
  withStyles(
    (theme) => ({
      ...styles(theme),
      ...localStyles(theme),
    }),
    { withTheme: true }
  )
)(TrailerHook);
